<template>
    <div
      dark
      id="home"
      style="background-color: white; height: 100vh; padding-top:64px; overflow-y:auto; overflow-x:hidden;"
      :class="$vuetify.breakpoint.mdAndUp ? 'Background' : 'BackgroundMobile'"
    >
    <v-layout style="">
      <!-- homepage web -->
      <div class="text">
        <v-layout align-center row wrap justify-center style="height:90vh;" fill-height class="hidden-sm-and-down">
          <v-flex xs12 sm12 md5 xl5 lg5 style="display: grid;" >
              <v-img src="/static/img/homepage/onechat_app.png" alt="banner onechat" style="max-height: 90vh;" />
              <v-flex xs12 sm12 md12 xl12 lg12  style="display: flex;margin-top: 4vh;color: black;">
                <v-layout justify-center>
                  <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="200" height="60" alt="download onechat" class="mr-4 download">
                  <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="200" height="60" alt="download onechat" class="download">
                </v-layout>
              </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md7 xl7 lg7 style="margin-top: 4vh;" >
            <v-layout align-center column justify-center wrap>
              <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 2vh;">
                <v-img src="/static/img/icons/logoonechat_full.png" alt="icon onechat" style="max-height: 100px; justify-content: center; width: 256px;" />
              </v-flex>
              <div style="margin-top: 6vh;color: black; font-size:20px;">
                  <v-flex xs12 sm12 xl12 lg12>
                    <span>" {{$t('Homepage.Title.title1')}}</span>
                  </v-flex>
                  <v-flex xs12 sm12 xl12 lg12 style="justify-content: center; align-items: center; display: flex;">
                    <span>{{$t('Homepage.Title.title2')}} "</span>
                  </v-flex>
              </div>
              <v-flex xs12 sm12 md12 xl12 lg12 class="hidden-sm-and-down" style="display: flex;margin-top: 6vh;color: black;">
                <v-btn to="/register" round dark class="btnhover text-transform" color="#2562B0">{{$t('Homepage.Button.join')}}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout align-center row wrap justify-center  class="hidden-sm-and-down">
          <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top:6em">
            <v-layout justify-center>
              <img src="/static/img/icons/logoonechat_full.png" width="120" height="50" />
               <h1 style="color:#2562B0; padding-left:20px;">{{$t('Homepage.Title.title3')}}</h1>
            </v-layout>
          </v-flex>
          <!-- ipad -->
          <v-layout row wrap justify-center style="margin-top:1.5em;" class="hidden-sm-and-down" v-if="$vuetify.breakpoint.width <= 1028 && $vuetify.breakpoint.height >=1366">
               <v-card color="#BFDBFF" width="700" style="border-radius:10px; ">
                  <p style="padding: 20px; 20px; 20px; 10px; margin-bottom:0px; font-size:20px;" >
                    &nbsp;&nbsp;&nbsp;&nbsp;{{$t('Homepage.Detail.detailOnechat')}}
                  </p>
               </v-card>
                <v-flex xs12 sm12 md12 xl12 style="margin-left:10em; margin-right:10em; margin-top:140px;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/one_platform.png"  style="height: 50vh;" >
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div>
                        <v-card color="#BFDBFF" tile max-width="400" height="150"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOneplatform')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/one2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;" >
                          <v-layout row justify-center>
                            <div>
                              <v-flex xs12 sm12 md12 >
                              <v-card color="#BFDBFF" tile width="250" height="130" style="margin-top:1em; border-radius:10px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">{{$t('Homepage.Detail.detailOnebox')}}</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/box2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round dark color="#2562B0" target="_blank" class="text-transform" href="https://box.one.th/">{{$t('Homepage.Button.moredetail')}}</v-btn>
                              </v-layout>
                            </div>

                            <!-- <v-flex xs6 sm6 md6> -->
                              <div>
                              <v-card color="#BFDBFF" tile width="250" height="130"  style="margin-top:1em; border-radius:10px; margin-left:20px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">{{$t('Homepage.Detail.detailOnemail')}}</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/mail2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              <v-layout justify-center>
                                <v-btn round color="#2562B0" style="margin-left:20px;" class="linkmail text-transform" target="_blank" href=" https://mail.one.th/">{{$t('Homepage.Button.moredetail')}}</v-btn>
                              </v-layout>
                              </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/message_image.gif"  style="height: 60vh; border-radius:30px;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center;">
                        <v-card color="#BFDBFF" tile width="400" height="150"  class="cardstyle" style="margin-left: 0; margin-right:0px; ">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOnechatFn1')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/multios.png"  style="height: 40vh;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs122 sm12 md12>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="">
                        <v-card color="#BFDBFF" tile width="400" height="190"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOnechatFn2')}}
                            </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;">
                          <v-layout justify-center>
                            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="130" height="50" alt="download onechat" class="mr-4 download">
                            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="130" height="50" alt="download onechat" class="download">
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/web_develop.png"  style="height: 40vh;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center;">
                        <v-card color="#BFDBFF" tile width="370" height="180"  class="cardstyle" style="margin-left: 0; margin-right:0px;">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOnechatFn3')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/bot2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-btn class="text-transform" round dark color="#2562B0" style="margin-top:20px;" :href="onechatDev" target="_blank">{{$t('Homepage.Button.moredetail')}}</v-btn>
                      </div>

                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-layout>
          <!-- web -->
          <v-layout align-center justify-space-around row wrap fill-height style="margin-top:1.5em; border-radius:10px;"  class="hidden-sm-and-down" v-else>
               <v-card color="#BFDBFF" width="700" style="border-radius:10px; ">
                  <p style="padding: 20px; 20px; 20px; 10px; margin-bottom:0px; font-size:20px;" >
                    &nbsp;&nbsp;&nbsp;&nbsp; {{$t('Homepage.Detail.detailOnechat')}}
                  </p>
               </v-card>

               <v-flex xs12 sm12 md12 xl12 style="margin-left:10em; margin-right:10em; margin-top:140px;">
                 <v-layout row wrap>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/one_platform.png"  style="height: 50vh;" >
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 sm2 md2></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout row wrap justify-start align-center fill-height>
                      <div>
                        <v-card color="#BFDBFF" tile max-width="400" height="150"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOneplatform')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/one2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;" >
                          <v-layout justify-center>
                            <div>
                              <v-flex xs12 sm12 md12 >
                              <v-card color="#BFDBFF" tile width="250" height="130" style="margin-top:1em; border-radius:10px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">{{$t('Homepage.Detail.detailOnebox')}}</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/box2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round dark color="#2562B0" target="_blank" class="text-transform" href="https://box.one.th/">
                                {{$t('Homepage.Button.moredetail')}}
                                </v-btn>
                              </v-layout>
                            </div>

                            <!-- <v-flex xs6 sm6 md6> -->
                              <div>
                              <v-card color="#BFDBFF" tile width="250" height="130"  style="margin-top:1em; border-radius:10px; margin-left:20px;" >
                                <v-layout align-center justify-center fill-height>
                                  <span class="textincard">{{$t('Homepage.Detail.detailOnemail')}}</span>
                                  <v-avatar tile size="58" class="iconcard">
                                    <img src="/static/img/homepage/icon/mail2x.png" />
                                  </v-avatar>
                                </v-layout>
                              </v-card>
                              <v-layout justify-center>
                                <v-btn class="text-transform" round color="#2562B0" style="margin-left:20px;" target="_blank" dark href=" https://mail.one.th/">{{$t('Homepage.Button.moredetail')}}</v-btn>
                              </v-layout>
                              </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs5 sm5 md5>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; margin-right:100px;">
                        <v-card color="#BFDBFF" tile width="400" height="150"  class="cardstyle" style="margin-left: 0;">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOnechatFn1')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 sm2 md2></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/message_image.gif"  style="height: 60vh; border-radius:30px; margin-left:150px;">
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
               <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/multios.png"  style="height: 40vh; margin-right:10em;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 sm2 md2></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout row wrap justify-start align-center fill-height>
                      <div style="margin-left:30px;">
                        <v-card color="#BFDBFF" tile width="400" height="190"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOnechatFn2')}}
                            </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;">
                          <v-layout justify-center>
                            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="130" height="50" alt="download onechat" class="mr-4 download">
                            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="130" height="50" alt="download onechat" class="download">
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>
              <v-flex xs12 sm12 md12 xl12 style="margin-left:20em; margin-right:20em; margin-top:10em;">
                 <v-layout row wrap>
                  <v-flex xs4 sm4 md4>
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; margin-right:120px;">
                        <v-card color="#BFDBFF" tile width="370" height="180"  class="cardstyle" style="margin-left: 0; margin-right:0px;">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincard">{{$t('Homepage.Detail.detailOnechatFn3')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/bot2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-btn class="text-transform" round dark color="#2562B0" style="margin-top:20px;" :href="onechatDev" target="_blank">{{$t('Homepage.Button.moredetail')}}</v-btn>
                      </div>

                    </v-layout>
                  </v-flex>
                  <v-flex xs3 sm3 md3></v-flex>
                  <v-flex xs5 sm5 md5>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/web_develop.png"  style="height: 40vh; margin-left:80px;">
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-layout>
        </v-layout>

      <!-- mobile -->
      <v-layout row wrap justify-center class="hidden-md-and-up" >
        <v-flex xs12 sm12 style="padding-top:3em;">
          <v-layout justify-center>
          <img src="/static/img/icons/logoonechat_full.png" alt="icon onechat" style="max-height: 100px; justify-content: center; width: 256px;" />
          </v-layout>
        </v-flex>
        <div style="margin-top: 2em;color: black; font-size:15px;">
          <v-flex xs12 sm12 xl12 lg12>
            <span style="font-size: 14px;">" {{$t('Homepage.Title.title1')}}</span>
          </v-flex>
          <v-flex xs12 sm12 xl12 lg12 style="justify-content: center; align-items: center; display: flex;">
            <span style="font-size: 14px;">{{$t('Homepage.Title.title2')}} "</span>
          </v-flex>
        </div>
        <v-flex xs12 sm12 md12 xl12 lg12 style="display: flex;margin-top: 6vh; margin-bottom:3em; color: black; justify-content: center;">
          <v-btn to="/register" round dark color="#2562B0" class="text-transform">{{$t('Homepage.Button.join')}}</v-btn>
        </v-flex>
        <img src="/static/img/homepage/onechat_app.png" alt="banner onechat" class="hidden-md-and-up" style="max-height: 40vh;"  />
        <v-flex xs12 sm12 md12 xl12 lg12 style="display: flex;margin-top: 4vh;color: black;">
          <v-layout justify-center>
            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" height="60" style="max-width:150px;" alt="download onechat" class="mr-4 download">
            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" height="60" style="max-width:150px;"  alt="download onechat" class="download">
          </v-layout>
        </v-flex>






          <!-- mobile -->
          <v-layout row wrap >
            <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top:6em" class="hidden-md-and-up">
              <v-layout justify-center>
                <img src="/static/img/icons/logoonechat_full.png" width="120" height="50" />
                  <h1 style="color:#2562B0; padding-left:20px;">{{$t('Homepage.Title.title3')}}</h1>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 style="margin-top:2em">
              <v-layout justify-center>
                <v-card color="#BFDBFF" width="480" style="border-radius:10px; ">
                    <p style="padding: 20px; 20px; 20px; 10px; font-size:18px; margin-bottom:0px;" >
                      &nbsp;&nbsp;&nbsp;&nbsp; {{$t('Homepage.Detail.detailOnechat')}}
                    </p>
                </v-card>
              </v-layout>
            </v-flex>

               <v-flex xs12 sm12 md12 xl12 style="margin-top:5em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/one_platform.png"  style="width: 90vw; height: intrinsic; margin-bottom:20px;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md6 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="">
                        <v-card color="#BFDBFF" tile width="300" height="130"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">{{$t('Homepage.Detail.detailOneplatform')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/one2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;" >
                          <v-layout justify-center>
                            <div>
                              <v-flex xs12 sm12>
                                <v-card color="#BFDBFF" tile width="150" height="150" style="margin-top:1em; border-radius:10px;" >
                                  <v-layout align-center justify-center fill-height>
                                    <span class="textincardMobile">{{$t('Homepage.Detail.detailOnebox')}}</span>
                                    <v-avatar tile size="58" class="iconcard">
                                      <img src="/static/img/homepage/icon/box2x.png" />
                                    </v-avatar>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn round dark color="#2562B0" target="_blank" class="text-transform" href="https://box.one.th/">{{$t('Homepage.Button.moredetail')}}</v-btn>
                              </v-layout>
                            </div>
                            <div>
                              <v-flex xs12 sm12>
                                <v-card color="#BFDBFF" tile width="150" height="150"  style="margin-top:1em; border-radius:10px; margin-left:30px;" >
                                  <v-layout align-center justify-center fill-height>
                                    <span class="textincardMobile">{{$t('Homepage.Detail.detailOnemail')}}</span>
                                    <v-avatar tile size="58" class="iconcard">
                                      <img src="/static/img/homepage/icon/mail2x.png" />
                                    </v-avatar>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                              <v-layout justify-center>
                                <v-btn class="text-transform" round color="#2562B0" style="margin-left:40px;" target="_blank" dark href=" https://mail.one.th/">{{$t('Homepage.Button.moredetail')}}</v-btn>
                              </v-layout>
                            </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-layout>
                  </v-flex>
                 </v-layout>
               </v-flex>

                  <v-flex xs12 sm12 md12 style="margin-top:5em;">
                    <v-layout justify-center>
                      <img src="/static/img/homepage/message_image.gif"  style="height: 60vh; border-radius:30px;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; ">
                        <v-card color="#BFDBFF" tile width="300" height="170"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">{{$t('Homepage.Detail.detailOnechatFn1')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-flex>

              <v-flex xs12 sm12 md12 xl12 style="margin-top:5em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/multios.png"  style="width: 90vw; height: intrinsic;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; ">
                        <v-card color="#BFDBFF" tile width="300" height="170"  class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">{{$t('Homepage.Detail.detailOnechatFn2')}}
                            </span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/chat2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                      </div>
                        <v-flex xs12 sm12 md12 lg12 style="margin-top:2em;">
                          <v-layout justify-center>
                            <img src="/static/img/download/rsz_googleplay.png" @click="downloadapp_and()" width="130" height="50" alt="download onechat" class="mr-4 download">
                            <img src="/static/img/download/rsz_appstore.png" @click="downloadapp_ios()" width="130" height="50" alt="download onechat download">
                          </v-layout>
                        </v-flex>
                    </v-layout>
                  </v-flex>
                 </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 xl12 style="margin-top:5em;">
                 <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center>
                      <img src="/static/img/homepage/web_develop.png"  style="width: 90vw; height: intrinsic;">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 style="margin-top:3em;">
                    <v-layout row wrap justify-center align-center fill-height>
                      <div style="display: flex; flex-direction: column; align-items: center; ">
                        <v-card color="#BFDBFF" tile width="300" height="180" class="cardstyle">
                          <v-layout align-center justify-center fill-height>
                            <span class="textincardMobile">{{$t('Homepage.Detail.detailOnechatFn3')}}</span>
                            <v-avatar tile size="58" class="iconcard">
                              <img src="/static/img/homepage/icon/bot2x.png" />
                            </v-avatar>
                          </v-layout>
                        </v-card>
                        <v-btn class="text-transform" round dark color="#2562B0" style="margin-top:20px;"  :href="onechatDev" target="_blank">{{$t('Homepage.Button.moredetail')}}</v-btn>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
          </v-layout>
      </v-layout>
      </div>
      <messageusDialog :dialogus="dialogus" @closeDialogus="closeDialogus"/>
      <ProblemDialog :dialogProblem="dialogProblem" @closeDialogProblem="closeDialogProblem"></ProblemDialog>
    </v-layout>
      <!-- footer web-->
      <div class="footer hidden-sm-and-down" >
        <v-footer height="auto" style="">
          <v-card class="flex" style="background-color:transparent;" flat tile>
            <v-card-title class="footertitle"  >
              <v-layout row wrap>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-end>
                    <img src="/static/img/homepage/onecentric_logo.png" style="width:260px;" alt="">
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-center style="padding-left:20px;">
                    <div >
                      <v-flex xs12 sm12 md12 style="padding-bottom:30px; ">
                        <v-layout justify-start>
                          <b>{{$t('Homepage.Footer.companyname')}}</b>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12  style="padding-bottom:30px;">
                        <v-layout justify-start>
                          <div>
                            <span style="display:flex;">{{$t('Homepage.Footer.date')}}</span>
                            <br/>
                            <span style="display:flex;">{{$t('Homepage.Footer.time')}}</span>
                          </div>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12 style="">
                        <v-layout row wrap>
                            {{$t('Homepage.Footer.address1')}}
                        </v-layout>
                        <v-layout row wrap>
                            {{$t('Homepage.Footer.address2')}}
                        </v-layout>
                        <v-layout row wrap>
                            {{$t('Homepage.Footer.address3')}}
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout align-start row wrap justify-start fill-height>
                    <div>
                      <v-flex xs12 sm12 md12>
                        <v-layout column wrap justify-center>
                          <v-flex>
                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px; ">
                                <v-icon>email</v-icon>
                                </v-flex>
                                <v-flex >
                                <v-layout row wrap align-center>
                                  <a href="mailto:onechat@one.th" style="cursor:pointer;" class="footerlink" >onechat@one.th</a>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>mdi-book-variant</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span @click="toPage('/policy')" style="cursor:pointer;" class="footerlink">{{$t('Homepage.Footer.policy')}}</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>chat</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span  style="cursor:pointer;" @click.stop="dialogus = !dialogus" class="footerlink">{{$t('Homepage.Footer.sendmsg')}}</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card-title>
          </v-card>
        </v-footer>

        <div class="problemIcon hidden-sm-and-down" >
          <v-tooltip left>
           <v-btn class="text-transform" fab dark slot="activator" @click.stop="dialogProblem = !dialogProblem" style="background: #2662af; height: 60px !important;width: 60px !important;">
             <v-icon style="font-size: 30px;">fas fa-bullhorn</v-icon>
           </v-btn>
          <span>{{$t('Homepage.Footer.report')}}</span>
        </v-tooltip>
        </div>
      </div>
      <!-- footer mobile-->
      <div class="footerMobile hidden-md-and-up">
        <!-- ipad -->
        <v-footer height="auto" style="" v-if="$vuetify.breakpoint.width >= 768">
          <v-card class="flex" style="background-color:transparent;" flat tile>
            <v-card-title class="footermobiletext">
              <v-layout row wrap>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-center>
                    <img src="/static/img/homepage/onecentric_logo.png" style="width:220px; height: intrinsic;" alt="">
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout justify-center style="padding-left:20px;">
                    <div>
                      <v-flex xs12 sm12 md12 style="padding-bottom:30px; ">
                        <b>{{$t('Homepage.Footer.companyname')}}</b>
                      </v-flex>
                      <v-flex xs12 sm12 md12  style="padding-bottom:30px;">
                        <span style="">{{$t('Homepage.Footer.date')}}</span>
                        <br>
                        <span>{{$t('Homepage.Footer.time')}}</span>
                      </v-flex>
                      <v-flex xs12 sm12 md12 style="padding-bottom:30px;">
                            <span>
                              {{$t('Homepage.Footer.address1')}}
                              <br>
                              {{$t('Homepage.Footer.address2')}}
                              <br>
                              {{$t('Homepage.Footer.address3')}}
                            </span>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <v-layout align-start row wrap justify-center fill-height>
                    <div>
                      <v-flex xs12 sm12 md12>
                        <v-layout column wrap justify-center>
                          <v-flex>
                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px; ">
                                <v-icon>email</v-icon>
                                </v-flex>
                                <v-flex >
                                <v-layout row wrap align-center>
                                  <a href="mailto:onechat@one.th" style="color:black !important;" class="footerlink">onechat@one.th</a>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>mdi-book-variant</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span @click="toPage('/policy')" style="cursor:pointer;" class="footerlink">{{$t('Homepage.Footer.policy')}}</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2 style="padding-right:30px; padding-bottom:15px;">
                                <v-icon>chat</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span  style="cursor:pointer;" @click.stop="dialogus = !dialogus" class="footerlink">{{$t('Homepage.Footer.sendmsg')}}</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card-title>
          </v-card>
        </v-footer>
        <v-footer height="auto" v-else>
          <v-card class="flex" style="background-color:transparent;" flat tile>
            <v-card-title class="">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-layout justify-center>
                    <img src="/static/img/homepage/onecentric_logo.png" style="width:300px; height: intrinsic;" alt="">
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout justify-center>
                    <div style="padding-left:25px;">
                    <v-flex xs12 sm12 md12 style="margin-bottom:15px;">
                      <b>{{$t('Homepage.Footer.companyname')}}</b>

                    </v-flex>
                    <v-flex xs12 sm12 md12 style="margin-bottom:15px;">
                      <span style="">{{$t('Homepage.Footer.date')}}</span>
                      <br>
                      <span>{{$t('Homepage.Footer.time')}}</span>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <!-- <v-layout align-center fill-height> -->
                          <span >
                            {{$t('Homepage.Footer.address1')}}
                            <br>
                            {{$t('Homepage.Footer.address2')}}
                            <br>
                            {{$t('Homepage.Footer.address3')}}
                          </span>
                        <!-- </v-layout> -->
                    </v-flex>
                      <v-flex xs12 sm12 md12 style="margin-top:15px;">
                        <v-layout column wrap justify-center>
                          <v-flex>
                            <v-layout row wrap>
                              <v-flex xs2 sm2>
                                <v-icon>email</v-icon>
                              </v-flex>
                              <v-flex >
                                <v-layout row wrap align-center>
                                  <a href="mailto:onechat@one.th" style="color:black !important;" class="footerlink">onechat@one.th</a>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2>
                                <v-icon>mdi-book-variant</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span @click="toPage('/policy')" style="cursor:pointer;" class="footerlink">{{$t('Homepage.Footer.policy')}}</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs2 sm2>
                                <v-icon>chat</v-icon>
                              </v-flex>
                              <v-flex>
                                <v-layout row wrap align-center>
                                  <span  style="cursor:pointer;" @click.stop="dialogus = !dialogus" class="footerlink">{{$t('Homepage.Footer.sendmsg')}}</span>
                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-footer>
      </div>
        <div class="problemIconMobile hidden-md-and-up">
          <v-tooltip left>
           <v-btn class="text-transform" fab dark slot="activator" @click.stop="dialogProblem = !dialogProblem" style="background: #2662af;   height: 40px !important;width: 40px !important;">
             <v-icon style="font-size: 20px;">fas fa-bullhorn</v-icon>
           </v-btn>
            <span>{{$t('Homepage.Footer.report')}}</span>
          </v-tooltip>
        </div>
    </div>
</template>

<script type="text/javascript">
  import messageusDialog from '@/components/chat/dialog/message/messageus'
  import ProblemDialog from '@/components/homepage/ProblemDialog'
  // import { Decode } from '@/services'
  export default {
    data () {
      return {
        onechat:'One Chat เป็นแอปพลิเคชันหนึ่งในตระกูลของ One Platform ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้',
        snackbar: true,
        deviceos: '',
        dialogProblem: false,
        dialogus: false,
        cardtext: [
          { text: 'ส่งข้อความ, ไฟล์, เสียง, รูปภาพ และยังมีฟังก์ชันอื่น ๆ' ,icon:'/static/img/homepage/icon/chat2x.png'},
          { text: 'บริการในตระกูล One Platform' ,icon:'/static/img/homepage/icon/one2x.png'},
          { text: 'เชื่อมต่อกับ One E-mail ที่ให้บริการฟรีอีเมล' ,icon:'/static/img/homepage/icon/mail2x.png'},
          { text: 'การใช้งาน Chat Bot' ,icon:'/static/img/homepage/icon/bot2x.png'},
          { text: 'มีบริการ One Box ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล' ,icon:'/static/img/homepage/icon/box2x.png'},
          { text: 'ระบบความน่าเชื่อถือในตัวบุคคล' ,icon:'/static/img/homepage/icon/security2x.png'},
        ],
        onechatDev: process.env.ONECHATDEV + 'docs'
        // status_login: ''
      }
    },
    components: {
      ProblemDialog,
      messageusDialog
    },
    methods: {
      toNewTab () {
        window.open(process.env.WEBchatdev, '_blank').focus()
      },
      toPage (page) {
        this.$router.push(page)
      },
      downloadapp () {
        if (this.deviceos === 'ios') {
          window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
        } else {
          window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
        }
      },
      downloadapp_ios () {
        window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
      },
      downloadapp_and () {
        window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
      },
      closeDialogProblem (value) {
        this.dialogProblem = value
      },
      closeDialogus (value) {
        this.dialogus = value
      }
    },
    created () {
      // console.log('kskksk')
      const device = require('current-device').default
      this.deviceos = device.os
      // console.log(require('current-device').default.os)
      this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
      // this.$i18n.locale = 'th'
    }
}
</script>

<style type="text/css" scoped>
.text-transform {
  text-transform: none !important;
}

/* a:link {
    text-decoration: none;
    color: white !important;
} */

/* a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color:white !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
} */
.footer {
   position: relative;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
   margin-top: 10em;
}
>>> div.typed-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

#particles-js {
  color: #fff;
  width: 100%;
  height: 100%;
  background-color: #000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

$text: #fff;
$link: #e34234;
$link-hover: #ba160c;
$background: #00356B;


#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background: $background
}

.text {
  /* position: absolute; */
  position: relative;
  top: 10%;
  /* top: 45%;
  right: 50%; */
  /* transform: translate(50%,-50%); */
  top: 15%;
  color: $text;
  width: 100%;
  padding: 2em 3em;
  font-family: 'CS ChatThaiUI' !important;
  /* height: 70vh; */
  /* overflow-y:auto; */
}
/*.textmo {
  position: absolute;
  top: 45%;
  right: 50%;
  transform: translate(50%,-50%);
  color: $text;
  width: 100%;
  padding: 2em 3em;
  font-family: 'CS ChatThaiUI' !important;
}*/
h1 {
  font-size: 2.25em;
  font-weight: 700;
  letter-spacing: -1px;
}
a,
a:visited {
  color: $link;
  transition: 0.25s;
}
a:hover,
a:focus {
  color: $link-hover;
}
.problemIcon {
  border-radius: 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 0px;
  border: 0px;
  background: transparent;
  position: fixed;
  z-index: 16000002;
  width: 130px;
  height: 80px;
  right: 10px;
  bottom: 15px;
}

/* .textFooter {
  text-align: right; padding-right: 5px;
  color: black;
}
.textFooterCompany {
  padding-left: 20px;
  padding-right: 20px;
  color: black !important;
} */
.iconDownload {
  margin-top: 0vw;
  width: 60px;
  height: 36px;
}
.Background{
  background-image: url('/static/img/homepage/wallpaper-website.png');
  object-fit: contain;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.BackgroundMobile{
  background-image: url('/static/img/homepage/wallpaper-mobile.png');
  object-fit: contain;
  background-size: 100% 100%;
}
.cardstyle{
  margin-top:10px;
  border-radius: 10px;
  margin-left:40px;
  margin-right:40px;
}
.cardstyleMobile{
  border-radius: 10px;
  margin-bottom: 55px;
  margin-left:20px;
  margin-right:20px;
}
.item {
  min-height: 50px;
  min-width: 80px;
   margin: 10px;
}
.textincard {
  font-size: 20px;
  /* font-weight:bold; */
  padding-left:2em;
  padding-right: 2em;
  text-align: center;
}
.textincardMobile {
  font-size: 16px;
  padding-left:1em;
  padding-right: 1em;
  text-align: center;
}
.iconcard{
  position: absolute;
  z-index: 1;
  top: -30px;
}
.problemIconMobile{
  border-radius: 10px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 0px;
  border: 0px;
  background: transparent;
  position: absolute;
  z-index: 16000002;
  /* width: 100px; */
  height: 80px;
  right: 10px;
  bottom: 15px;
}

/*  */
.centered {
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.download {
  cursor: pointer;
}
.footertitle{
  padding-top: 50px;
  padding-bottom: 10px;
}
.footermobiletext{
  padding-top: 50px;
  padding-bottom: 10px;
}
.footerMobile{
  padding-top: 50px;
  /* padding-bottom: 10px; */
}
.btnhover:hover{
  color: white;
}
.footerlink{
  color:black;
  text-decoration: none;
}
.footerlink:hover{
  color:#1976d2;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/Homepage.vue